export default "__VITE_ASSET__CFHNQ5gT__"